<template lang="pug">
    el-dialog(title="调整赛制", width="40%",:visible.sync='visible' :append-to-body="true" :modal-append-to-body='false' @close="closeForm()" class='fromlist')
        el-form(:model="ruleForm", :inline="false" :rules="rules", ref="ruleForm", label-width="120px", @submit.native.prevent class='chose')
                el-form-item(label="签位:" prop="applySize" class='applySize')
                    el-col(style="width:35%;")
                        el-input(type="number" :min='ruleForm.joinCount' v-model='ruleForm.applySize' style="width:100%;" @change='changeapplySize' clearable placeholder="请填写签位")
                        font.font_later() (已报名{{ruleForm.joinCount}}队!)
                    el-col(style="width:54%;")
                      el-form-item(label="级别队伍数:" prop="teamNum" )
                        el-input(v-model='ruleForm.teamNum' style="width:100%;" @change='changeGroupNum'  clearable placeholder="请填写级别队伍数")
                //- 迭代三
                el-form-item(label="第一阶段赛制:" prop="firstFormat" )
                    el-col(style="width:35%;")
                        el-select(v-model='ruleForm.firstFormat' style="width:100%;" placeholder="请选择比赛类型" @change='changefirstFormat'  clearable)
                          el-option(v-for="(item, index) in firstFormat" :label="item.label" :value='item.value')
                    //- el-col(style="width:20%;" class="line") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*组数&nbsp;&nbsp;
                    el-col(style="width:54%;")
                      el-form-item(label="组数:" prop="groupNum" )
                        el-input(v-model='ruleForm.groupNum' style="width:100%;" @change='changeGroupNum' :disabled='ruleForm.firstFormat===1?false:true' clearable placeholder="请填写组数")
                el-form-item(label="第二阶段赛制:" prop="city")
                    el-col(style="width:35%;")
                        el-select(v-model='ruleForm.secondFormat' style="width:100%;" placeholder="请选择比赛类型" @change='changeSecondCompeti' :disabled='ruleForm.firstFormat===1&&ruleForm.groupNum!=1&&ruleForm.groupNum!=""?false:true'  clearable)
                          el-option(v-for="(item, index) in secondFormat" :label="item.label" :value='item.value')
                    //- el-col(style="width:20%;" class="line") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*交叉数&nbsp;&nbsp;
                    el-col(style="width:54%;")
                      el-form-item(label="交叉数:" )
                        el-select(v-model='ruleForm.crossNum' style="width:100%;" placeholder="请选择交叉数" :disabled='ruleForm.firstFormat===1&&ruleForm.secondFormat==4?false:true' clearable)
                          el-option(v-for="(item, index) in CrossingNum" :label="item.label" :value='item.value')
        span.dialog-footer(slot="footer")
            el-button(type="primary" @click='sure') 确 定
            el-button(@click="visible=false  ") 取 消
</template>
<script>
export default {
	name: 'AdjustGameSys',
	data () {
		return {
			visible: false,
			type: -1,
			ruleForm: {
				firstFormat: '',
				groupNum: '',
				crossNum: '',
				secondFormat: '',
				ctId: '',
				applySize: '',
				joinCount: '',
				teamNum: ''
			},
			rules: {
				firstFormat: [
					{
						required: true,
						message: '赛制不能为空!',
						trigger: 'change'
					}
				],
				groupNum: [
					{
						required: true,
						message: '组数不能为空!',
						trigger: 'change'
					}
				],
				applySize: [
					{
						required: true,
						message: '签位不能为空!',
						trigger: 'blur'
					},
					{
						pattern: /^[0-9]*[1-9][0-9]*$/,
						message: '请输入正整数',
						trigger: 'blur'
					}
				],
				teamNum: [
					{
						required: true,
						message: '级别队伍数量不能为空!',
						trigger: 'change'
					}
				]
			},
			firstFormat: [
				{ value: 0, label: '淘汰附加赛' },
				{ value: 1, label: '小组循环赛' }
			],
			secondFormat: [
				{ value: 2, label: '同名次小组循环赛' },
				{ value: 3, label: '同名次淘汰附加赛' },
				{ value: 4, label: '交叉淘汰附加赛' }
			],
			CrossingNum: [
				{ value: '2', label: '2' }
				// { value: '4', label: '4' },
				// { value: '8', label: '8' }
			]
		}
	},
	methods: {
		init (id, type) {
			this.type = type
			this.$nextTick(() => {
				this.visible = true
				// console.log("this.$refs['ruleForm']:",this.$refs['ruleForm'])
				if (this.$refs['ruleForm']) {
					this.$refs['ruleForm'].resetFields()
				}
			})
			this.ruleForm.groupNum = ''
			this.ruleForm.secondFormat = ''
			this.ruleForm.crossNum = ''
			this.ruleForm.firstFormat = ''
			this.ruleForm.applySize = ''
			this.ruleForm.joinCount = ''
			this.ruleForm.teamNum = ''
			this.ruleForm.ctId = id
			this.ctType = ''
			this.$http({
				url: this.$http.adornUrl(`/ctCompetition/getId/` + id),
				method: 'get'
			}).then((data) => {
				this.ctType = data.bean.ctType
				this.ruleForm.applySize = data.bean.applySize * 1
				this.ruleForm.joinCount = data.bean.joinCount * 1
				this.ruleForm.teamNum = data.bean.teamNum
					? data.bean.teamNum * 1
					: 16
				if (data.bean.competitionMatchFormatList.length != 0) {
					this.ruleForm.firstFormat =
						data.bean.competitionMatchFormatList[0].matchFormat
					this.ruleForm.groupNum =
						data.bean.competitionMatchFormatList[0].groupNum
					if (
						data.bean.competitionMatchFormatList[0]
							.matchFormat
					) {
						// alert(1)
						this.rules.groupNum[0].required = true //控制表单是否必填组数
						this.$refs.ruleForm.validateField(
							'groupNum'
						)
					} else {
						this.rules.groupNum[0].required = false //控制表单是否必填组数
						this.$refs.ruleForm.validateField(
							'groupNum'
						)
					}
					if (
						data.bean.competitionMatchFormatList
							.length > 1
					) {
						this.ruleForm.secondFormat =
							data.bean.competitionMatchFormatList[1].matchFormat
						this.ruleForm.crossNum =
							data.bean.competitionMatchFormatList[1].crossNum
					}
				}
			})
		},
		changeapplySize () {
			if (this.ruleForm.joinCount > this.ruleForm.applySize) {
				this.applytestingnumber1()
				return false
			}
			this.VerificationInfo()
		},
		// 签位数应小于128，并且组数要被签位数整除
		VerificationInfo () {
			// alert(1)
			if (this.ruleForm.joinCount > this.ruleForm.applySize) {
				this.applytestingnumber1()
				return false
			}
			const isDivisible = (dividend, divisor) =>
				dividend % divisor === 0
			console.log(
				this.ruleForm.applySize / this.ruleForm.teamNum === 4
			)
			if (this.ctType === 5) {
				if (
					this.ruleForm.applySize / this.ruleForm.teamNum >
					4
				) {
					this.applytesting()
					return false
				}
			}
			if (this.ctType === 6) {
				if (
					this.ruleForm.applySize / this.ruleForm.teamNum >
					8
				) {
					this.applytesting1()
					return false
				}
			}
			// if (this.ruleForm.applySize > 128) {
			// 	this.applytesting()
			// 	return false
			// }
			if (
				!isDivisible(
					this.ruleForm.applySize,
					this.ruleForm.teamNum
				)
			) {
				this.applytestingnumber()
				return false
			}
			return true
		},
		// 修改第二赛制验证限制
		changeSecondCompeti () {
			this.$forceUpdate()
			if (this.ruleForm.secondFormat != 4) {
				this.ruleForm.crossNum = ''
			} else {
				if (
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						2 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						4 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						6
				) {
				} else {
					return this.applychecking1()
				}
			}
			// 如果第二赛制为同名次小组循环赛需要验证
			if (this.ruleForm.secondFormat == 2) {
				if (
					this.ruleForm.groupNum >= 2 &&
					this.ruleForm.groupNum <= 6
				) {
				} else {
					return this.tiemchecking()
				}
			}
		},
		changeGroupNum () {
			this.$forceUpdate()
			// 组数为1或者空需要验证
			if (
				this.ruleForm.groupNum == 1 ||
				this.ruleForm.groupNum == ''
			) {
				this.ruleForm.secondFormat = ''
				this.ruleForm.crossNum = ''
			}
			// 如果第二赛制为淘汰赛需要验证
			if (this.ruleForm.secondFormat == 4) {
				if (
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						2 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						4 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						6
				) {
				} else {
					return this.applychecking1()
				}
			}
			// 如果第二赛制为同名次小组循环赛需要验证
			if (this.ruleForm.secondFormat == 2) {
				if (
					this.ruleForm.groupNum >= 2 &&
					this.ruleForm.groupNum <= 6
				) {
				} else {
					return this.tiemchecking()
				}
			}
			// 组数与签位的验证
			if (
				this.ruleForm.groupNum !== '' &&
				this.ruleForm.groupNum !== null &&
				this.ruleForm.applySize !== '' &&
				this.ruleForm.applySize !== null
			) {
				if (
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						2 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						3 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						4 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						5 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						6
				) {
				} else {
					return this.applychecking()
				}
			}
		},
		changefirstFormat () {
			// 第一赛制为空或者为0的验证
			if (
				this.ruleForm.firstFormat == 0 ||
				this.ruleForm.firstFormat == ''
			) {
				this.ruleForm.groupNum = ''
				this.ruleForm.secondFormat = ''
				this.ruleForm.crossNum = ''
				this.rules.groupNum[0].required = false
				this.$refs.ruleForm.validateField('groupNum')
				// this.rules.cbClubPhotoList = [{ required: true, message: '俱乐部照片不能为空' }]
				if (this.ruleForm.applySize > 64) {
					this.applytesting()
				}
			} else {
				this.rules.groupNum[0].required = true
				this.$refs.ruleForm.validateField('groupNum')
			}
		},
		sure () {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					// 组数和签位之间的限制
					if (!this.verification()) {
						return
					}
					const h = this.$createElement
					console.log(h)
					this.$msgbox({
						title: '提示',
						message: h('p', null, [
							h('p', '确认调整赛制？'),
							h(
								'p',
								'若已有成绩录入，系统将清空所有成绩及积分，重新生成新的对阵表！请谨慎操作，数据不可恢复。'
							)
						]),
						showCancelButton: true,
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							this.$http({
								url: this.$http.adornUrl(
									`/ctCompetition/changeFormat`
								),
								method: 'post',
								data: this.ruleForm
							}).then((data) => {
								if (data && data.code === 0) {
									this.$message({
										message: '操作成功',
										type: 'success',
										duration: 1500,
										onClose: () => {
											this.$emit(
												'refreshSortFormatrList'
											)
											this.visible = false
										}
									})
								} else {
								}
							})
						})
						.catch(() => {
							this.$message({
								type: 'info',
								message: '已取消修改'
							})
						})
				}
			})
		},
		tiemchecking () {
			this.$alert(
				'因二阶段同名次小组循环赛系统支持2-6签的小组对阵，故一阶段小组循环赛分组数也需满足2-6组。请重新设置组数！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
			return false
		},
		applytesting () {
			this.$alert(
				'挑战赛事总分组（即总签位 / 级别队伍数）应不大于4！。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		applytesting1 () {
			this.$alert(
				'群英赛事总分组（即总签位 / 级别队伍数）应不大于8！。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		applychecking () {
			this.$alert(
				'当前系统支持单组（即级别队伍数量/组数）签位数为2/3/4/5/6签。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		applychecking1 () {
			this.$alert(
				'当前系统支持单组（即级别队伍数量/组数）签位数为2/4/6签。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		applytestingnumber () {
			this.$alert(
				'当前系统支持签位数必须为级别队伍数量的倍数。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		applytestingnumber1 () {
			this.$alert(
				'当前系统支持签位数必须大于等于已报名人数。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		verification () {
			if (!this.VerificationInfo()) {
				return
			}
			// alert(1)
			if (
				this.ruleForm.secondFormat == '' ||
				this.ruleForm.secondFormat == null
			) {
				if (this.ruleForm.groupNum > 1) {
					this.$message.error(
						'赛制仅为小组循环赛，组数只支持单组！'
					)
					return false
				}
			}
			if (this.ruleForm.secondFormat == 4) {
				if (
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						2 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						4 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						6
				) {
				} else {
					return this.applychecking1()
				}
			}
			// 如果第二赛制为同名次小组循环赛需要验证
			if (this.ruleForm.secondFormat == 2) {
				if (
					this.ruleForm.groupNum >= 2 &&
					this.ruleForm.groupNum <= 6
				) {
				} else {
					return this.tiemchecking()
				}
			}
			// if (
			// 	this.ruleForm.firstFormat == 0 ||
			// 	this.ruleForm.firstFormat == ''
			// ) {
			// 	this.ruleForm.groupNum = ''
			// 	this.ruleForm.secondFormat = ''
			// 	this.ruleForm.crossNum = ''
			// 	if (this.ruleForm.applySize > 64) {
			// 		this.applytesting()
			// 		return false
			// 	}
			// }
			// 组数和签位之间的限制
			if (
				this.ruleForm.groupNum !== '' &&
				this.ruleForm.groupNum !== null &&
				this.ruleForm.applySize !== '' &&
				this.ruleForm.applySize !== null
			) {
				if (
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						2 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						3 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						4 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						5 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						6
				) {
				} else {
					// alert(1)
					this.applychecking()
					return false
				}
				if (this.ruleForm.secondFormat == 4) {
					if (
						this.ruleForm.crossNum == '' ||
						this.ruleForm.crossNum == ''
					) {
						this.$message.error('请选择交叉数')
						return false
					}
				}
			}
			return true
		},
		closeForm () {
			this.visible = false
		}
	}
}
</script>
<style>
/* .fromlist{
  position: relative;
  height: 200px;
} */
.applySize {
	margin-bottom: 0 !important;
}
.chose {
	padding-top: 50px;
	/* padding-left: 30%; */
}
.chose .el-form-item {
	width: 100%;
}
</style>
